(ns frontend.ui.component.modal-dialog.style
  (:require
   [frontend.ui.style.theme.core :refer [color]]
   [garden.color :refer [transparentize]]
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]))

(defn header
  []
  {:display          "flex"
   :justify-content  "space-between"
   :padding          "16px"
   :flex             "0 0 auto"
   :background-color (theme/color [:modal-dialog :header :bg])
   :color            (theme/color [:modal-dialog :header :text])
   :font-weight      "600"
   :font-size        "1.125rem"
   :border-bottom    (space-join ["1px" "solid"
                                  (theme/color [:modal-dialog :header :border-bottom])])})

(defn body
  [body-style-override]
  (merge {:padding  "16px"
          :flex     "1 1 auto"
          :overflow "auto"}
         body-style-override))

(defn footer
  []
  {:padding        "16px"
   :flex           "0 0 auto"
   :display        "flex"
   :flex-direction "row"
   :border-top     (space-join ["1px" "solid" (theme/color [:modal-dialog :footer :border-top])])})

(defn footer-left-container
  []
  {:flex            "1 1 auto"
   :display         "flex"
   :justify-content "start"
   :align-content   "center"
   :flex-direction  "row"})

(defn footer-right-container
  []
  {:flex            "1 1 auto"
   :display         "flex"
   :justify-content "end"
   :align-content   "center"
   :flex-direction  "row"})

(defn text-uppercase
  []
  {:text-transform "uppercase"
   :letter-spacing "0.1px"
   :font-family    "News Gothic MT"
   :font-weight    "bold"})

(defn modal-dimmer
  []
  {:position         "fixed"
   :left             "0"
   :right            "0"
   :top              "0"
   :bottom           "0"
   :z-index          "1055"
   :width            "100%"
   :height           "100%"
   :overflow-x       "hidden"
   :overflow-y       "auto"
   :background-color "rgba(0,0,0,.7)"})

(defn modal-content
  [{:keys [size] :as props}]
  {:display     "flex"
   :align-items "center"
   :min-height  "calc(100% - 1rem)"
   :margin      "0 auto"
   :font-family (or (:font-family props) "News Gothic MT")
   :padding     "16px"
   :max-width   (cond
                  (number? size)
                  (str size "px")

                  (string? size)
                  size

                  (keyword? size)
                  (case size
                    :xl "80%"
                    :sm "800px"
                    :xs "640px")
                )})

(defn modal-inner
  []
  {:width          "100%"
   :display        "flex"
   :flex-direction "column"
   :max-height     "100vh"
   :box-shadow     "0 0 6px rgba(0,0,0,.25)"
   :background     "#fff"})

(defn modal
  [visible?]
  {:display  (if visible? "block" "none")
   :position "fixed"
   :z-index  100
   :left     0
   :top      0
   :width    "100%"
   :height   "100%"
   ;; This enables scroll if needed
   :overflow "auto"})


(defn footer-left
  []
  ^{:media {{:screen :only :max-width "1200px"}
            {:gap "8px"}}}
  {:display "flex"
   :flex    "1 1 auto"
   :justify-content "start"
   :gap     "16px"})

(defn footer-right
  []
  {:display "flex"
   :flex    "1 1 auto"
   :justify-content "end"
   :gap     "16px"})


(defn spacing-top-bottom
  []
  {:padding-top    "16px"
   :padding-bottom "16px"})

(defn spacing-left
  []
  ^{:media {{:screen :only :max-width "1200px"}
            {:margin-left "8px"}}}
  {:display     "inline-block"})
